import {useGTMDispatch} from './react-gtm-hook/index'
import {transformAlgoliaItemsForBasketEventsGA4} from './utils'
import { useRapidDeliveryStore } from '../store/hooks/useStore'

export const useAddToWishlistTracking = () => {
  const sendDataToGTM = useGTMDispatch()
  const {isRapidDeliveryBooked} = useRapidDeliveryStore()

  const sendAddToWishlistData = (addToWishlistData) => {
    const { 
      product,
      cartLocation,
      viewingCategoryId,
      location,
      hitItemIndex
    } = addToWishlistData
    setTimeout(() => {
      try {
        const transformAlgoliaData = {
          items: [product],
          cartLocation,
          viewingCategoryId,
          location,
          hitItemIndex,
          isRapidDeliveryBooked
        }
        const _items = transformAlgoliaItemsForBasketEventsGA4(transformAlgoliaData)
        sendDataToGTM({
          event: 'add_to_wishlist',
          ecommerce: {
            currency: 'GBP',
            value: _items[0].price * _items[0].quantity,
            items: _items, 
          }
        })
      } catch (error) {
        console.error('useAddToWishlistTracking error within setTimeout: ' + error.message)
      }
    }, 0)
  }
  return sendAddToWishlistData
}